import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import Home from './components/Home';
import Cart from './components/Cart';
import { Box, createTheme, ThemeProvider } from '@mui/material';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CartAndCheckout from './components/CartAndCheckout'; // Import your CartAndCheckout component


const stripePromise = loadStripe('your-publishable-key-here');

const theme = createTheme({
  palette: {
    primary: {
      main: '#B8860B',
    },
    background: {
      default: '#FFF8DC',
      paper: '#FFFFFF',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CartProvider>
        <Router>
          <Box
            sx={{
              minHeight: '100vh',
              background: 'linear-gradient(145deg, #FFF8DC 0%, #FFD700 100%)',
              paddingBottom: 4
            }}
          >
            <Elements stripe={stripePromise}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/cart-checkout-container" element={<CartAndCheckout />} /> 
              </Routes>
            </Elements>
          </Box>
        </Router>
      </CartProvider>
    </ThemeProvider>
  );
}

export default App;
